export default {
    heas:[],
    hea:{},
}
